<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'AppPage',
  created() {
    if (this.$router.path !== "/home")
      this.$router.replace("home")
  }

}
</script>

<style lang="less">
html {
  height: 100%;
  width: 100%;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
}

div {
  box-sizing: border-box;
}
</style>
